import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { ReportFooterTimestamp } from '../../utils/reportUtils';
import { useTranslation } from 'react-i18next';

interface AppointmentData {
  id: number;
  TimeFrom: string;
  TimeTo: string;
  patientName: string;
  MRN: string;
  mobileNumber: string;
  doctor: string;
  department: string;
  appointmentReason: string;
  appointmentDate: string;
}

const tableCellStyle = {
  fontSize: '0.875rem',
  padding: '6px 8px',
  borderColor: '#eee',
  color: '#333',
};

interface Props {
  filteredAppointmentData: AppointmentData[];
}

const AppointmentReport: React.FC<Props> = ({
  filteredAppointmentData,
}) => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tAppointmentForm } = useTranslation('appointment_form');
  const { t: tRegistration } = useTranslation('registration_lang');
  return (
    <Box
      sx={{
        p: '0px 35px 35px 35px',
        backgroundColor: '#fff',
        color: '#333',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <Typography variant="h6" sx={{ mb: 1, color: '#444' }}>
        {tGeneral('Appointment_Report')}
      </Typography>

      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, mb: 4, maxHeight: 800, overflow: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {[
                tAppointmentForm('Date'),
                tAppointmentForm('timeFromLabel'),
                tAppointmentForm('timeToLabel'),
                tAppointmentForm('patientName'),
                tRegistration('Registration.MRN'),
                tRegistration('Registration.Text_Phone_Number'),
                tAppointmentForm('departmentLabel'),
                tRegistration('Registration.Doctor'),
                tAppointmentForm('appointmentReasonLabel'),
              ].map((heading, i) => (
                <TableCell
                  key={i}
                  sx={{
                    ...tableCellStyle,
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                    textTransform: 'capitalize',
                  }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredAppointmentData?.map((item, i) => (
              <TableRow key={item.id || i}>
                <TableCell sx={tableCellStyle}>{item.appointmentDate || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.TimeFrom || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.TimeTo || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.patientName || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.MRN || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.mobileNumber || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.department || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.doctor || '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{item.appointmentReason || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ReportFooterTimestamp />
    </Box>
  );
};

export default AppointmentReport;
